import Api from '.';

/**
 * 
 * Retrieve all business partners.
 */
export function getBusinessPartners() {
    return Api.get('/business-partner');
}
